<template>
      <v-container style="background-color:white">
        <v-toolbar dark class="secondary">
          <v-toolbar-title>{{editProject ? 'Edit Project' : 'Add Completed Project' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-checkbox v-if="projectType === 'new'" hidden-xs-only v-model="completedProject" label="Completed Project?" color="success" hide-details></v-checkbox> -->
          <div v-if="editProject && user.permissions.others.sendProjectToLeads" @click="ifSendToLeads = true"><v-btn>Return to Leads</v-btn></div>
          <v-btn class="ml-4" dark flat icon @click="$emit('closeDialog')"><v-icon>cancel</v-icon></v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <!-- Contact Form -->
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
                <v-layout>
                  <v-flex title indigo--text v-if="contact || completedContact">
                    Create Project For: {{ customerSelect ? customerSelect : completedContact.name }}
                  </v-flex>
                  <v-toolbar dark color="primary" v-if="!contact && !editProject && !completedContact">
                    <v-toolbar-title><v-icon class="mr-2">person</v-icon>Customer:</v-toolbar-title>
                    <v-autocomplete autofocus :loading="loading" :items="items" :search-input.sync="search" v-model="customerSelect" cache-items
                      class="mx-3" flat hide-no-data hide-details label="Search Customers" solo-inverted @change="getContactDetails">
                    </v-autocomplete>
                    <v-btn @click="createContact" flat class="primary"><v-icon left>person_add</v-icon>Add Customer</v-btn>
                  </v-toolbar>
                </v-layout>
                <p v-if="!customerSelect && !completedContact && validating === true" class="mt-3 title red--text">You Must Enter a Customer</p>
                <v-layout mt-4 row wrap v-if="projectType == 'new'">
                  <v-flex xs12 md7>
                      <v-text-field v-model="project.name" label="Project Name" :rules="nameRules" :counter="30" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-text-field mask="########" v-model="project.contract_amount" label="Contract Amount" :rules="validationRequired" prepend-icon="attach_money" required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="projectType == 'new' && !completedProject">
                  <v-flex sm6 xs12>
                    <v-text-field v-model="project.property_survey" label="Property Survey?"></v-text-field>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-text-field v-model="project.other_designs" label="Other Designs?"></v-text-field>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-text-field v-model="project.financing" label="Financing?"></v-text-field>
                  </v-flex>
                    <v-flex sm3 xs6>
                      <v-text-field v-model="project.budget_min" label="Min Budget" value="0.00" prefix="$"></v-text-field>
                    </v-flex>
                    <v-flex sm3 xs6>
                      <v-text-field v-model="project.budget_max" label="Max Budget" value="0.00" prefix="$"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="projectType == 'new' && completedProject">
                  <v-flex xs12 sm6>
                    <v-dialog ref="startmodal" v-model="startmodal" persistent lazy full-width width="290px">
                      <v-text-field slot="activator" v-model="pickerStartDate" label="Project Start Date" prepend-icon="event" readonly></v-text-field>
                      <v-date-picker  v-on:change="setStartDate" v-model="pickerStartDate" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="startmodal = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.startmodal.save(pickerStartDate)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-dialog ref="completedmodal" v-model="completedmodal" :return-value.sync="pickerCompletedDate" persistent lazy full-width width="290px">
                      <v-text-field slot="activator" v-model="pickerCompletedDate" label="Project Completed Date" prepend-icon="event" readonly></v-text-field>
                      <v-date-picker v-on:change="setCompletedDate" v-model="pickerCompletedDate" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="completedmodal = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.completedmodal.save(pickerCompletedDate)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="projectType == 'new' && !editProject">
                  <v-flex xs12>
                    <v-checkbox v-model="addressSameAsContact" label="Project Address Same As Customer" color="success" hide-details></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="projectType == 'new' && !addressSameAsContact">
                  <v-flex xs12>
                    <v-text-field v-model="project.address" name="address" label="Address"></v-text-field>
                  </v-flex>
                  <v-flex sm6 xs12>
                    <v-text-field v-model="project.city" name="city" label="City"></v-text-field>
                  </v-flex>
                  <v-flex sm3 xs6>
                    <v-text-field v-model="project.state" name="state" label="State (i.e. FL)"></v-text-field>
                  </v-flex>
                  <v-flex sm3 xs6>
                    <v-text-field v-model="project.zip" name="zip" label="Zip"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs9>
                    <v-text-field v-model="project.building_dept" name="building_dept" label="Building Department" required></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field v-model="project.gate_code" name="gate_code" label="Gate Code"></v-text-field>
                  </v-flex>
                </v-layout>
                <template>
                  <v-flex sm6 xs12>
                    <v-layout row>
                      <v-select v-model="project.source" :rules="validationRequired" :items="sourceOptions" item-text="name" label="How did they hear about us?" prepend-icon="record_voice_over" required></v-select>
                      <v-btn v-if="user.permissions.dropdowns.referralSources" flat icon @click="editDropdownDialog = true"><v-icon>edit</v-icon></v-btn>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="project.source">
                    <v-text-field v-model="project.referred_by" label="Provide Any Additional Referral Information" prepend-icon="record_voice_over"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select v-model="salesRep" :rules="validationRequired" :items="userNames" label="Sales Rep:" prepend-icon="person_add" required></v-select>
                  </v-flex>
                </template>
                <v-layout row wrap v-if="projectType == 'new'">
                  <v-flex xs12>
                    <v-select clearable v-model="project.builder" @input="getBuilderContacts(project.builder)" :items="builderDropDownList" label="Assign a Builder" required></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select clearable v-model="project.builder_contact" v-if="project.builder" :items="builderContactsDropDownList" :label="'Project Contact from ' + project.builder" required></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="project.hoa" label="HOA / Neighborhood"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea v-model="project.description" multi-line rows="1" auto-grow label="Description of Work"></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea v-model="project.projectNotes" multi-line rows="1" auto-grow label="General Project Notes"></v-textarea>
                  </v-flex>
                </v-layout>
                <!-- Project Uploader -->
                <div v-if="!editProject">
                  <v-chip outline color="orange" @click="showUploader = !showUploader"><v-icon left>insert_drive_file</v-icon>{{ !showUploader ? 'Upload Files' : 'Hide Uploader' }}</v-chip>
                  <uploader v-if="showUploader" @filesUploaded="getUploadFiles" :uploadPath="'projects/' + this.docTimestamp + '/vault/' "  />
                </div>
                <v-layout row wrap v-if="projectType == 'new'" style="margin-top:20px">
                  <v-flex>
                      <v-btn flat class="primary" @click="createProject"><v-icon left>ballot</v-icon>Save Project</v-btn>
                      <v-btn v-if="!completedProject && !editProject" flat class="primary" @click="createProjectAndTasks"><v-icon left>ballot</v-icon>Save Project and Create Tasks</v-btn>
                      <v-btn flat class="secondary" @click="$emit('closeDialog')">Cancel</v-btn>
                  </v-flex>
                  <v-flex>
                    <p class="red--text title" v-if="errors">Looks like you are missing information. Please make sure all required fields are completed.</p>
                  </v-flex>
                  <v-dialog v-model="loadingTasks" width="500px">
                    <v-container>
                      <v-flex>
                        <p>Creating Tasks.... Please Wait....</p>
                      </v-flex>
                    </v-container>
                  </v-dialog>
                </v-layout>
            </v-container>
          </v-form>
    <!-- Send back to leads? -->
      <v-dialog v-if="ifSendToLeads" v-model="ifSendToLeads" width="600px" height="400px">
        <v-toolbar dark class="secondary">
          <v-icon dark left>person</v-icon>
        <v-toolbar-title>Send This Project Back to Leads?</v-toolbar-title>
      </v-toolbar>
          <v-alert style="margin-top: -5px;" dark :value="true" color="info" icon="info">You are about to send this project back to the leads phase... <br>Are you sure you want to continue?
             <v-layout mt-3>
               <v-btn @click="sendProjectToLeads" class="error">Send Back To Leads</v-btn>
               <v-btn @click="ifSendToLeads = false" class="secondary">CANCEL</v-btn>
             </v-layout>
          </v-alert>
      </v-dialog>
    <!-- End: Send back to leads? -->
    <!-- Edit Drop Down -->
    <v-dialog max-width="600px" v-model="editDropdownDialog">
      <edit-dropdown v-if="editDropdownDialog" dropdownName="referralSources" @closeDialog="editDropdownDialog = false"/>
    </v-dialog>
    <!-- End: Edit Drop Down -->
      </v-container>
</template>

<script>
import { db, storage } from '../../firebaseInit'
import Uploader from '../../helpers/Uploader'
import EditDropdown from '../../helpers/EditDropdown'
import _ from 'lodash'

export default {
  props: ['contact', 'editContact', 'visable', 'editProject', 'completedProject', 'completedContact'],
  data () {
    return {
      editDropdownDialog: false,
      salesRep: null,
      ifSendToLeads: false,
      getContact: {},
      contactList: [],
      items: [],
      search: null,
      customerSelect: null,
      loading: false,
      loadingTasks: false,
      projectType: 'new',
      validating: false,
      valid: true,
      errors: false,
      startmodal: false,
      completedmodal: false,
      showUploader: false,
      builderDropDownList: [],
      builderContactsDropDownList: [],
      pickerStartDate: null,
      pickerCompletedDate: null,
      docTimestamp: null,
      uploadedFileList: [],
      addressSameAsContact: true,
      project: {id: null, status: 'Pre-Construction', sales_rep: null, name: null, contract_amount: null, start_date: new Date(), completed_date: null, building_dept: null, property_survey: null, other_designs: null, financing: null, budget_min: 0, budget_max: 0, address: null, city: null, state: null, zip: null, gate_code: null, hoa: null, description: null, notes: null, projectNotes: null, builder: null, builder_contact: null, referred_by: null, source: null},
      projectBeforeChanges: null,
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 50) || 'Name must be less than 50 characters'
      ],
      validationRequired: [
        v => !!v || 'Field is required'
      ],
      // rules: {
      //   fileName: v => {
      //     return [A-Za-z0-9].test(v)
      //   }
      // }
      fileNameRules: [
        v => {
          return /^[A-Za-z0-9 _-]*$/.test(v) || 'Use only letters, numbers, spaces, dashes, and underscores'
        }
      ],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 20,
        headers: { 'My-Awesome-Header': 'header value' }
      }
    }
  },
  mounted () {
    this.setId()
    if (this.completedContact) {
      this.getContact = this.completedContact
    }
    // Get Contact List
    if (this.contact) {
      if (this.contact.secondaryContact_first_name) {
        this.customerSelect = this.contact.first_name + ' ' + this.contact.last_name + ' and ' + this.contact.secondaryContact_first_name + ' ' + this.contact.secondaryContact_last_name
        this.getContact = this.contact
      } else {
        this.customerSelect = this.contact.first_name + ' ' + this.contact.last_name
        this.getContact = this.contact
      }
    } else {
      this.contactList = this.$store.getters.getContactSearchList.map(a => a.name)
    }
    // Get Builder List
    this.BuildersList()
    // Set addressSameAsContact to false if Contact has no address
    if (!this.getContact.address) {
      this.addressSameAsContact = false
    }
    // Edit Contact List From Props
    if (this.editProject) {
      const objKeys = Object.keys(this.project)
      objKeys.forEach(k => {
        if (this.editProject[k] !== 'undefined') {
          this.project[k] = this.editProject[k]
        }
      })
      // Add the current Builder contact to the dropdown list or it will not show up for edits
      if (this.editProject.builder_contact) {
        this.builderContactsDropDownList.push(this.editProject.builder_contact)
      }
      this.projectBeforeChanges = Object.assign({}, this.project)
    }
    // Assign Sales Rep
    const sr = this.userList.filter(f => f.id === this.project.sales_rep)[0]
    const SalesFirstName = sr && sr.first_name ? sr.first_name : ''
    const SalesLastName = sr && sr.last_name ? sr.last_name : ''
    this.salesRep = SalesFirstName + ' ' + SalesLastName
  },
  watch: {
    salesRep () {
      const repData = this.userList.filter(f => f.first_name + ' ' + f.last_name === this.salesRep)
      this.project.sales_rep = repData && repData[0] ? repData[0].id : null
    },
    search (val) {
      val && val !== this.select && this.querySelections(val)
    },
    getContact () {
      this.addProjectName()
    }
  },
  computed: {
    sourceOptions () {
      return this.$store.getters.referralSources
    },
    userNames () {
      return this.userList.filter(f => f.if_sales_rep === true).map(m => m.first_name + ' ' + m.last_name)
    },
    userList () {
      return _.orderBy(this.$store.getters.userList, 'first_name')
    },
    registerDialog: {
      get () {
        return this.visable
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    user () {
      return this.$store.getters.user
    }
  },
  methods: {
    sendProjectToLeads () {
      this.$store.dispatch('sendProjectToLeads', {project: this.editProject, contact: this.editContact})
      this.ifSendToLeads = false
      this.$router.push('/leads')
    },
    addProjectName () {
      if (this.getContact.city) {
        this.project.name = this.getContact.last_name + ' - ' + this.getContact.city
      } else {
        this.project.name = this.getContact.last_name + ' Project'
      }
    },
    createContact () {
      this.$emit('createContact')
    },
    getUploadFiles (files) {
      this.uploadedFileList = []
      files.forEach(value => {
        let selectedFileName = value.ref.name.replace(/\.[^/.]+$/, '')
        let selectedFileExtension = value.ref.name.split('.').pop()
        this.uploadedFileList.push({id: this.docTimestamp, name: selectedFileName, type: value.metadata.contentType, extension: selectedFileExtension, path: value.ref.fullPath, timestamp: new Date(), created_by: this.user.id, active: true})
      })
    },
    setId () {
      let milliseconds = String((new Date()).getTime())
      let timestamp = milliseconds + '-' + Math.floor(Math.random() * 1000)
      this.docTimestamp = timestamp
      this.project.id = timestamp
    },
    BuildersList () {
      let obj = this.$store.getters.builderList
      obj.forEach(item => {
        this.builderDropDownList.push(item.company_name)
      })
      this.builderDropDownList = this.builderDropDownList.sort()
    },
    getBuilderContacts (companyName) {
      const builders = this.$store.getters.builderList
      const builder = builders.filter(filter => filter.company_name === companyName)
      builder[0].builder_contacts.forEach(item => {
        this.builderContactsDropDownList.push(item.first_name + ' ' + item.last_name)
      })
    },
    onUpload () {
      // Create a Storage Ref
      if (!this.docTimestamp) {
        this.setId()
      }
      if (this.$refs.form.validate()) {
        let newFile = new File([this.selectedFile], this.selectedFileName + '.' + this.selectedFileExtension, {type: this.selectedFile.type})
        const putFile = storage.ref('projects/' + this.docTimestamp + '/' + newFile.name).put(newFile)

        putFile.on('state_changed', snapshot => {
          this.progressBar = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        })
        putFile.then(response => {
          this.selectedFile = null
          this.selectedFileName = null
          this.selectedFileExtension = null
          this.selectedFileNotes = null
          this.initiateChooseFile = false
        })
        .catch(error => console.log(error))
      }
    },
    createProject () {
      // Is Project Complete?
      if (this.completedProject === true) {
        this.project.status = 'Completed'
      }
      // Set Contact if Exists
      if (this.contact) {
        this.getContact = this.contact
      }
      // Check Validation
      this.validating = true
      // If Creation of New Project
      if (!this.editProject) {
        if (this.$refs.form.validate() && (this.customerSelect || this.completedContact)) {
          if (!this.project.id) {
            this.project.id = this.docTimestamp
          }
          if (!this.getContact || !this.getContact.id) {
            // this.getContactDetails()
          }
          if (this.getContact && this.getContact.id) {
            this.contactAddressPass()
            const projectData = {...this.project, files: this.uploadedFileList, contact_id: this.getContact.id, completedProject: this.completedProject ? this.completedProject : null, waiting_on_template: !this.completedProject}
            this.$store.dispatch('createProject', projectData)
            this.closeContactAndProject()
          }
        } else {
          this.errors = true
        }
      }
      if (this.editProject) {
        // Find Changes
        const objKeys = Object.keys(this.projectBeforeChanges)
        let differences = {}
        objKeys.forEach(k => {
          if (this.projectBeforeChanges[k] !== this.project[k]) {
            differences = {...differences, [k]: this.project[k]}
          }
        })
        let changesFrom = {}
        objKeys.forEach(k => {
          if (this.projectBeforeChanges[k] !== this.project[k]) {
            changesFrom = {...differences, [k]: this.projectBeforeChanges[k] ? this.projectBeforeChanges[k] : null}
          }
        })
        const payload = {changes: differences, changesFrom: changesFrom, id: this.project.id, name: this.project.name}
        this.$store.dispatch('editProject', payload)
        this.$emit('closeDialog')
        // If Contract Amount Change Update Contact Opportunities Object
        if (payload.changes.contract_amount || payload.changes.source || payload.changes.referred_by || payload.changes.sales_rep) {
          let contactList = []
          db.collection('projects').doc(this.project.id).get().then(project => {
            const contactIds = Object.keys(project.data().contacts)
            contactIds.forEach(contactId => {
              db.collection('contacts').doc(contactId).get().then(contact => {
                contact.data().opportunities.forEach((opp, i) => {
                  if (opp.project === this.project.id) {
                    let allOpps = contact.data().opportunities
                    if (payload.changes.contract_amount) {
                      allOpps[i].contract_amount = payload.changes.contract_amount
                    }
                    if (payload.changes.source) {
                      allOpps[i].source = payload.changes.source
                    }
                    if (payload.changes.referred_by) {
                      allOpps[i].referred_by = payload.changes.referred_by
                    }
                    if (payload.changes.sales_rep) {
                      allOpps[i].sales_rep = payload.changes.sales_rep
                    }
                    db.collection('contacts').doc(contact.id).update({opportunities: allOpps})
                    contactList.push(contact.data())
                  }
                })
              })
            })
          })
        }
      }
    },
    createProjectAndTasks () {
      this.createProject()
      const payload = {projectId: this.docTimestamp, projectName: this.project.name, taskTemplate: 'Pre-Construction', startDate: new Date()}
      this.$store.dispatch('getTaskList', payload)
    },
    getContactDetails () {
      let contactDetails = this.$store.getters.getContactSearchList.filter(f => { return f.name === this.customerSelect })
      contactDetails = Object.assign({}, ...contactDetails)
      db.collection('contacts').doc(contactDetails.id).get().then(query => {
        this.getContact = {...query.data(), id: query.id}
      })
    },
    contactAddressPass () {
      if (this.addressSameAsContact) {
        this.project.address = this.getContact.address
        this.project.city = this.getContact.city
        this.project.state = this.getContact.state
        this.project.zip = this.getContact.zip
      }
      if (!this.getContact.address) {
        this.getContact.address = null
      }
      if (!this.getContact.city) {
        this.getContact.city = null
      }
      if (!this.getContact.state) {
        this.getContact.state = null
      }
      if (!this.getContact.zip) {
        this.getContact.zip = null
      }
    },
    setStartDate () {
      this.project.start_date = new Date(new Date(this.pickerStartDate).getTime() + 57600000)
    },
    setCompletedDate () {
      this.project.completed_date = new Date(new Date(this.pickerCompletedDate).getTime() + 57600000)
    },
    closeContactAndProject () {
      this.$emit('closeDialog')
    },
    querySelections (v) {
      this.loading = true
      // Simulated ajax query
      setTimeout(() => {
        this.items = this.contactList.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      }, 500)
    }
  },
  components: {
    Uploader,
    EditDropdown
  }
}
</script>

<style scoped>
.buttons {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/projects/CreateProject.vue